module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer "
  }, [_c('div', {
    staticClass: "row container"
  }, [_c('div', {
    staticClass: "col col-s12"
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/footerBM.png'
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1272d6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Site-footer.vue
// module id = 352
// module chunks = 0